<template>
  <section id="education" class="flex flex-col justify-around">
    <h2 class="py-2 mb-1 v-highlight text-h2">
      <router-link class="header-anchor" :to="{ hash: '#education' }"
        >Education</router-link
      >
    </h2>
    <div class="snippet-experiences-024">
      <div class="row flex">
        <div class="item-bullet"></div>
        <div class="item">
          <h4>德明財經科技大學, 工程師學位, 資訊科技系, 2014 ~ 2018</h4>
          <p class="py-2">
            <b
              ><i
                >Independent Study - 智慧型腦波偵測暨情緒舒緩系統 2016年 6 月 -
                2017 年 9 月</i
              ></b
            ><br />
            <span>負責主要應用程序開發</span><br />
            <span>Android Application (android studio) </span><br />
            <span>LAMP set up </span><br />
            <span>CRUD api (php) </span><br />
            <span>2017 年全國大學學院軟件創作大賽 - 最佳關注獎 </span><br />
            <span>系上年度專題第一名 </span><br />
            <span>獲得科技部工程司補助 </span><br />
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
